module.exports = __webpack_public_path__ + "img/flask-svgrepo-com.ca395264.svg";